import { UMEventsResponsibleGaming } from "../../mediator/types";
import { getUMEvent } from "../../mediator/events";
import mediator from "../../mediator";

export const openResponsibleGamingScreen = (
  screen: UMEventsResponsibleGaming
) => {
  const event = getUMEvent(screen);
  mediator.dispatch({
    type: event.trigger
  });
};
